export const ADD_INGREDIENT = 'ADD_INGREDIENT';
export const REMOVE_INGREDIENT = 'REMOVE_INGREDIENT';
export const SET_INGREDIENTS = 'SET_INGREDIENTS';
export const INIT_INGREDIENTS_FAILED = 'INIT_INGREDIENTS_FAILED';

export const PURCHASE_INIT = 'PURCHASE_INIT';
export const PURCHASE_START = 'PURCHASE_START';
export const PURCHASE_SUCCESS = 'PURCHASE_SUCCESS';
export const PURCHASE_FAIL = 'PURCHASE_FAIL';

export const FETCH_ORDERS__START = 'FETCH_ORDERS__START';
export const FETCH_ORDERS__SUCCESS = 'FETCH_ORDERS__SUCCESS';
export const FETCH_ORDERS__FAIL = 'FETCH_ORDERS__FAIL';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const SETH_AUTH_REDIRECT_PATH = 'SETH_AUTH_REDIRECT_PATH';